import { createAction, createEntityAdapter, createSlice, PayloadAction } from '@reduxjs/toolkit';

import { RootState } from '@/store/root-state';
import { ForecastProductGroupModel } from '@/models/forecast-product-group.model';

const forecastProductGroupAdapter = createEntityAdapter<ForecastProductGroupModel>({
    selectId: (group) => group.uid,
});

const initialState = forecastProductGroupAdapter.getInitialState({
    isLoading: false,
});

export type ForecastProductGroupsState = typeof initialState;

namespace asyncActions {
    export const fetchAll = createAction('staff/forecastProductGroups/async/fetchAll');
}

const slice = createSlice({
    name: 'forecastProductGroups' as const,
    initialState,
    reducers: {
        setIsLoading: (state, action: PayloadAction<boolean>) => {
            state.isLoading = action.payload;
        },
        setAll: (state, action: PayloadAction<ForecastProductGroupModel[]>) => {
            forecastProductGroupAdapter.setAll(state, action.payload);
        },
    },
});

const productsAdapterSelectors = forecastProductGroupAdapter.getSelectors(
    (state: RootState) => state.forecastProductGroups
);

namespace sliceSelectors {
    export const isLoading = (state: RootState) => state.forecastProductGroups.isLoading;
}

export const forecastProductGroupSlice = {
    ...slice,
    asyncActions,
    selectors: {
        ...productsAdapterSelectors,
        ...sliceSelectors,
    },
};
